import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  MmAccordionModule,
  MmAlertModule,
  MmButtonModule,
  MmCheckboxModule,
  MmContextualMenuModule,
  MmDialogModule,
  MmFormFieldModule,
  MmIconModule,
  MmQuantityPickerModule,
  MmSelectModule,
  MmSpinnerModule,
  MmTableModule,
  MmTooltipModule
} from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { OrderHistoryAlertService } from './services/order-history-alert.service';
import { OrdersHistoryListEffects } from './store/orders-history-list';
import { DateRangeViewModule } from '~shared/pipes/date-range-view/date-range-view.module';
import { DocumentDialogComponent } from './components/documents-dialog/document-dialog.component';
import { ORDERS_HISTORY_FEATURE_NAME } from './constants';
import { reducers } from './store';
import { ReceiveDocumentLinkEffects } from './store/receive-document-link';
import { ReturnsEffects } from './store/returns';
import {
  ReturnProductsDialogComponent
} from './components/returns/return-products-dialog/return-products-dialog.component';
import { ActiveFeaturesModule } from '~shared/modules/active-features/active-features.module';
import {
  OrderReturnInstructionsComponent
} from './components/order-return-instructions/order-return-instructions.component';
import {
  OrdersHistoryListComponent
} from './components/orders-history-list/orders-history-list.component';
import {
  OrderHistoryListItemComponent
} from './components/order-history-list-item/order-history-list-item.component';
import {
  OrderHistoryDetailsComponent
} from './components/order-history-details/order-history-details.component';
import {
  OrderHistoryDetailsAddressComponent
} from './components/order-history-details-address/order-history-details-address.component';
import {
  OrderHistoryDetailsPaymentComponent
} from './components/order-history-details-payment/order-history-details-payment.component';
import { OrderLinesItemComponent } from './components/order-lines-item/order-lines-item.component';
import { OrderLineDeliveryComponent } from './components/order-line-delivery/order-line-delivery.component';
import { ProductDeliveryPipe } from './pipes/product-delivery.pipe';
import {
  TrackingNumberListComponent
} from './components/tracking-number-list/tracking-number-list.component';
import {
  OrderLineActionsBarComponent
} from './components/order-line-actions-bar/order-line-actions-bar.component';
import { OrderConfirmDialogComponent } from './components/order-confirm-dialog/order-confirm-dialog.component';
import { ReturnOrderLineComponent } from './components/return-order-line/return-order-line.component';
import {
  DownloadInvoicesDialogComponent
} from './components/download-invoices-dialog/download-invoices-dialog.component';
import { DocumentNamePipe } from './pipes/document-name.pipe';
import { MatIconModule } from '@angular/material/icon';
import { AppLinkGaTrackingModule } from '~shared/components/app-link-ga-tracking/app-link-ga-tracking.module';
import { PipesModule } from '~app/modules/account/modules/orders-history/pipes/pipes.module';
import { OrderLineVasItemComponent } from './components/order-line-vas-item/order-line-vas-item.component';
import { OrdersHistoryRoutingModule } from './orders-history-routing.module';

const DIALOGS = [
  DocumentDialogComponent,
  ReturnProductsDialogComponent,
  OrderReturnInstructionsComponent,
  OrderConfirmDialogComponent,
  ReturnOrderLineComponent,
  DownloadInvoicesDialogComponent,
];

@NgModule({
  declarations: [
    ...DIALOGS,
    ReturnProductsDialogComponent,
    OrderReturnInstructionsComponent,
    OrdersHistoryListComponent,
    OrderHistoryListItemComponent,
    OrderHistoryDetailsComponent,
    OrderHistoryDetailsAddressComponent,
    OrderHistoryDetailsPaymentComponent,
    OrderLinesItemComponent,
    OrderLineDeliveryComponent,
    ProductDeliveryPipe,
    TrackingNumberListComponent,
    OrderLineActionsBarComponent,
    OrderConfirmDialogComponent,
    ReturnOrderLineComponent,
    DownloadInvoicesDialogComponent,
    OrderLineVasItemComponent,
    DocumentNamePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(ORDERS_HISTORY_FEATURE_NAME, reducers),
    EffectsModule.forFeature([
      ReceiveDocumentLinkEffects,
      ReturnsEffects,
      OrdersHistoryListEffects
    ]),
    TranslateModule,
    MmAlertModule,
    MmIconModule,
    MmCheckboxModule,
    MmContextualMenuModule,
    MmButtonModule,
    MmFormFieldModule,
    MmSpinnerModule,
    QaLocatorsModule,
    MmAccordionModule,
    MmDialogModule,
    MmQuantityPickerModule,
    MmSelectModule,
    ActiveFeaturesModule,
    MmTooltipModule,
    DateRangeViewModule,
    MmTableModule,
    MatIconModule,
    AppLinkGaTrackingModule,
    PipesModule,
    OrdersHistoryRoutingModule,
  ],
  providers: [OrderHistoryAlertService],
})
export class OrdersHistoryModule {
}
